import { put, select, takeLatest } from 'redux-saga/effects';
import { selectScopedSiteID } from 'reduxStore/app/selectors';
import { inceptionActions } from './slice';
import { settingsActions } from 'reduxStore/settings/slice';
import { Notification } from 'zComponents/atoms';

export function* verifyConnection() {
	const superFetchModule = yield import('library/helpers/superFetch');
	const superFetch = superFetchModule.default;
	try {
		const res = yield superFetch.post(`/inception/verify`);
		if (res.statusCode === 200) {
			const name = res.data?.systemInfo?.ProductName || 'Inception controller';
			Notification('success', `Connection verified — ${name} reachable.`);
			yield put(inceptionActions.verifyConnectionSuccess());
		} else {
			throw new Error(res.error);
		}
	} catch (error) {
		Notification('error', error.message || 'Failed to verify the Inception connection.');
		yield put(inceptionActions.verifyConnectionError(error.message));
	}
}

export function* triggerSync() {
	const superFetchModule = yield import('library/helpers/superFetch');
	const superFetch = superFetchModule.default;
	try {
		// Files this run's audit rows under the picked site; null keeps them org-wide.
		const siteID = yield select(selectScopedSiteID);
		const res = yield superFetch.post(`/inception/sync`, { siteID });
		if (res.statusCode === 200) {
			// Sync progress + completion arrive via SYNC_PROGRESS/SYNC_COMPLETE
			// sockets; refresh org settings so the syncing flag renders immediately.
			yield put(settingsActions.loadOrgSettings());
			yield put(inceptionActions.triggerSyncSuccess());
		} else {
			throw new Error(res.error);
		}
	} catch (error) {
		Notification('error', error.message || 'Failed to trigger Inception sync.');
		yield put(inceptionActions.triggerSyncError(error.message));
	}
}

export default function* inceptionSagas() {
	yield takeLatest(inceptionActions.verifyConnection, verifyConnection);
	yield takeLatest(inceptionActions.triggerSync, triggerSync);
}
